import React, { useState,useEffect } from 'react';
import { useSelector } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import Button from '../../shared-components/Button/custom-button';
import DateRangeDropdown from './DateRange';
import dayjs from 'dayjs';
import { format } from 'date-fns';
import { useDispatch } from 'react-redux';
import { downloadResponses, fetchRespondentsData } from './respondant-store/respondant-actions';
import { useParams } from 'react-router-dom';

const Respondents = () => {
  const { id } = useParams();

  const { currentCode, currentSurveyName } = useSelector(
    (state) => state.projectList
  );
  const dispatch = useDispatch();

  const [dates, setDates] = useState({
    startDate: format(new Date(new Date().setDate(new Date().getDate() - 7)), 'yyyy-MM-dd'), // 7 days ago
    endDate: format(new Date(), 'yyyy-MM-dd') // Today
  });
 const [columns, setColumns] = useState([]);
  const [sortField, setSortField] = useState('response_id');
  const [sortOrder, setSortOrder] = useState(1); 
  const [filteredData, setFilteredData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10); // Default rows per page
  const [first, setFirst] = useState(0); // First row offset
  const [currentPage, setCurrentPage] = useState(1); // Current page number
  // Fetch data on mount or when survey ID changes
  useEffect(() => {
    if (id) {
      handleSearch(1, rows); // Initial load with default dates
    }
  }, [id]);

  const handleSearch = (page = currentPage, pageSize = rows,sortFieldParam = sortField,
  sortOrderParam = sortOrder) => {
   const validatedPage = Math.max(1, Number(page) || 1);
    const validatedPageSize = Math.max(1, Number(pageSize) || 10);
    const startRow = (validatedPage - 1) * validatedPageSize + 1;
    const endRow = startRow + validatedPageSize - 1;
     const sortParam = sortOrderParam === -1 ? `${sortFieldParam} desc` : sortFieldParam;
    dispatch(
      fetchRespondentsData(
        id,
        dates.startDate,
        dates.endDate,
        sortParam,
        startRow,
        endRow
      )
    ).then((apiResponse) => {
      setFilteredData(apiResponse?.data || []);
      setTotalRecords(parseInt(apiResponse?.RecordCount) || 0);
      
      const responseData = apiResponse?.data || [];
      
      if (responseData.length > 0) {
        const firstResponse = responseData[0];
        
        // Standard columns that exist in every response
        const baseColumns = [
          {
            field: "response_id",
            header: "Response ID",
            sortable: true,
            style: { minWidth: '120px' }
          },
          {
            field: "created_on",
            header: "Submission Date",
            sortable: true,
            body: (rowData) => formatDate(rowData.created_on),
            style: { minWidth: '180px' }
          }
        ];
        
        const questionColumns = Object.keys(firstResponse)
          .filter(key => key.startsWith('Q') && key.includes('-'))
          .map(questionId => ({
            field: questionId,
            header: getQuestionHeader(questionId),
            body: (rowData) => formatAnswer(rowData[questionId]),
            style: { minWidth: '150px' }
          }));
        
        setColumns([...baseColumns, ...questionColumns]);
      }
    });
  };

  const onPageChange = (event) => {
  const newPage = event.page + 1; // Convert to 1-based index
    const newPageSize = event.rows;
    
    // Update all state first
    setFirst(event.first);
    setRows(newPageSize);
    setCurrentPage(newPage);
    
    // Then trigger search with new parameters
    handleSearch(newPage, newPageSize);
  };

  const handleReset = () => {
    setDates({
      startDate: format(new Date(new Date().setDate(new Date().getDate() - 7)), 'yyyy-MM-dd'),
      endDate: format(new Date(), 'yyyy-MM-dd')
    });
    setFirst(0);
    //setCurrentPage(1);
   setFirst(0);
    setCurrentPage(1);
    setRows(10);
    handleSearch(1, 10);
  };

  // Download Excel
  const handleDownload = () => {
    dispatch(downloadResponses(id, dates.startDate, dates.endDate));
  };
useEffect(() => {
    if (filteredData.length > 0) {
     
      const firstResponse = filteredData[0];
      
      // Standard columns that exist in every response
      const baseColumns = [
        {
          field: "response_id",
          header: "Response ID",
          sortable: true,
          style: { minWidth: '120px' }
        },
        {
          field: "created_on",
          header: "Submission Date",
          sortable: true,
          body: (rowData) => formatDate(rowData.created_on),
          style: { minWidth: '180px' }
        }
      ];
       const questionColumns = Object.keys(firstResponse)
        .filter(key => key.startsWith('Q') && key.includes('-'))
        .map(questionId => ({
          field: questionId,
          header: getQuestionHeader(questionId), // Custom function to format header
          body: (rowData) => formatAnswer(rowData[questionId]),
          style: { minWidth: '150px' }
        }));
        console.log('Question Columns:', questionColumns);
      setColumns([...baseColumns, ...questionColumns]);
    }
  }, [filteredData]);
    const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };
   const getQuestionHeader = (questionId) => {
    // You might want to fetch actual question text from another API
    // or maintain a question mapping in your state
    return `Question ${questionId.split('-')[1]}`; // Example: "Q1-4" → "Question 4"
  };
const handleSort = (e) => {
  setSortField(e.sortField);
  setSortOrder(e.sortOrder);
  handleSearch(currentPage, rows, e.sortField, e.sortOrder);
};

  const formatAnswer = (answer) => {
    if (answer === null || answer === undefined) return '';
    if (Array.isArray(answer)) return answer.join(', ');
    return answer.toString();
  };
  return (
    <div className="container-fluid py-4">
      {/* Header Row */}
      <div className="row align-items-center mb-3 px-3">
        <div className="col-md-6 col-12 fw-bold">
          <span>{currentCode} | {currentSurveyName}</span>
        </div>
        
      </div>

      {/* Filters + Table Card */}
      <div className="row px-4">
        <div className="col-12 bg-white rounded border px-3 py-3 mb-3">
          {/* Filters */}
          <div className="row align-items-end">
            {/* <div className="col-lg-3 col-12 mb-3">
              <label className="form-label fw-semibold">Search Projects</label>
              <span className="p-input-icon-left w-100">
                <i className="pi pi-search" />
                <InputText
                  type="text"
                  className="w-100"
                  placeholder="Enter keyword..."
                  // onChange={(e) => handleSearch(e.target.value)}
                />
              </span>
            </div> */}

            <div className="col-lg-3  col-12 mb-3">
              <label className="form-label fw-semibold">Date Range</label>
              <DateRangeDropdown 
                initialDates={{
                  startDate: new Date(dates.startDate),
                  endDate: new Date(dates.endDate)
                }}
                onChange={(newDates) => 
                  setDates({
                    startDate: format(newDates.startDate, 'yyyy-MM-dd'),
                    endDate: format(newDates.endDate, 'yyyy-MM-dd')
                  })
                }
              />
            </div>

            {/* <div className="col-lg-3  col-12 mb-3">
             
            </div> */}

            <div className="col-lg-3 col-12 mb-3">
              <Button
                label="Search"
                icon="pi pi-check"
                className="p-button-sm p-button-primary me-2"
                style={{  fontSize: '12px', padding: '6px 5px' }}
                 onClick={handleSearch}
              />
              <Button
                label="Reset"
                icon="pi pi-times"
                className="p-button-sm p-button-secondary"
                style={{  fontSize: '12px', padding: '6px 9px' }}
                 onClick={handleReset}
              />
            </div>
            <div className="col-lg-6  col-12 mb-3 text-end">
              <Button
            name="Download"
            label="Download"
            className="p-button-warning"
            icon="pi pi-eye"
            onClick={handleDownload}
            style={{ backgroundColor: '#1F3BB3', fontSize: '12px', padding: '6px 5px' }}
          />
            </div> 
          </div>

          {/* Table */}
          <div className="table-responsive mt-3">
             <DataTable
              value={filteredData}
              lazy 
              paginator
              rows={rows}
              first={first}
              totalRecords={totalRecords}
               onSort={handleSort}
              sortField={sortField}
              sortOrder={sortOrder}
              rowsPerPageOptions={[5, 10, 20, 50]}
              onPage={onPageChange}
              scrollable
              style={{ width: '100%' }}
              emptyMessage={
                <div className="text-center py-2">
                  It looks like there are no respondents for this survey.
                </div>
              }
            >
                   {columns.map((col) => (
            <Column
              key={col.field}
              field={col.field}
              header={col.header}
              sortable={col.sortable}
              body={col.body}
              style={col.style}
            />
          ))}
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Respondents;
